import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { MatDatepicker, MatDialog, MatDialogConfig, MatPaginatorIntl } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { AccountService } from '../../../../../service/finzy-flex/account/account.service';
import { ProductList } from '../../../../../model/finzy-flex/product-list.model';
import { Keys, StorageService } from '../../../../../service/storage.service';
import { LrsDownloadPopupComponent } from './lrs-download-popup/lrs-download-popup.component';
import { LrsFrequency, LrsList } from '../../../../../model/finzy-flex/lrs-list.model';
import * as moment from 'moment-timezone';
import { ConfigService } from '../../../../../service/config.service';
import { Toaster, Type } from '../../../../../toaster/Toaster';

@Component({
    selector: 'app-flex-reports',
    templateUrl: './flex-report.component.html',
    styleUrls: ['./flex-report.component.scss'],
    providers: [ MatPaginatorIntl ],
})

export class FlexReportComponent implements OnInit, AfterViewInit {
    private readonly matPaginatorIntl: MatPaginatorIntl;
    private readonly matDialog: MatDialog;
    private readonly storageService: StorageService;
    private readonly accountService: AccountService;
    private readonly configService: ConfigService;
    private productList: ProductList;
    private productTypes = [];
    public lrsReportList: LrsList;
    public pageLength: number;
    public pageSize: number = 10;
    public showTotalPages: number = 4;
    public fromDatePlaceHolder: string = 'From';
    public toDatePlaceholder: string = 'To';
    public selectedFromDate: Date;
    public selectedToDate: Date;
    public selectedYear: number = null;
    public yearList: number[] = [];
    public showEmptyLrsPage: boolean = false;
    public readonly currentYear: number = moment().year();
    public startYear: number;

    @HostListener('window:resize', ['$event']) 
    onChangeScreenSize(event) {
        this.checkScreenSize();
    }
    constructor(
        matPaginatorIntl: MatPaginatorIntl,
        matDialog: MatDialog,
        storageService: StorageService,
        activatedRoute: ActivatedRoute,
        accountService: AccountService,
        configService: ConfigService,
    ) {
        this.matPaginatorIntl = matPaginatorIntl;
        this.matDialog = matDialog;
        this.storageService = storageService;
        this.accountService = accountService;
        this.configService = configService;
        activatedRoute.data.subscribe((data) => {
            this.productList = data.product;
        });
    }
    async ngOnInit() {
        this.matPaginatorIntl.itemsPerPageLabel = 'Show';
        await this.getSubProductsList();
        await this.getLrsListDetails(true);
        this.startYear = this.configService.getLrsYearStartFrom();
        this.yearList = Array(this.currentYear+1 - this.startYear).fill(0).map((d, i) => i + this.startYear);
    }

    ngAfterViewInit() {
        this.checkScreenSize();
    }

    private async getLrsListDetails(initialCall: boolean, frequency: string = LrsFrequency.MONTHLY, fromDate?: Date, toDate?: Date) {
        this.lrsReportList = await this.accountService.getLrsListData(this.getLenderId(), fromDate, toDate, frequency);
        if (initialCall) {
            (this.lrsReportList?.data.length < 1 ) && (this.showEmptyLrsPage = true);
        }
        this.paginationDetails();
        return this.lrsReportList;
    }

    private getLenderId():string {
        return this.storageService.getItem(Keys.LENDER_ID);
    }

    private async getSubProductsList() {
        this.productTypes = [];
        this.productList?.data.forEach((product) => {
            this.productTypes.push(product.code);
        });
    }

    private checkScreenSize() {
        if (window.innerWidth <= 480) {
            this.showTotalPages =  2;
        } else {
            this.showTotalPages = 4;
        }
    }

    private paginationDetails() {
        this.pageLength = this.lrsReportList?.total;
        this.pageSize = this.lrsReportList?.count;
        return this.pageLength, this.pageSize;
    }

    public openLrsReportDownloadPopup() {
        const matDialogConfig: MatDialogConfig = {
            height: 'auto',
            width: '80%',
            data: {
                lenderId: this.getLenderId(),
                productTypes: this.productTypes,
            },
            panelClass: 'lrs-download-popup'
        }
        this.matDialog.open(LrsDownloadPopupComponent, matDialogConfig);
    }

    public async filterByYear(year: number) {
        this.lrsReportList.data = [];
        if (year == 0) {
            this.selectedYear = undefined;
            await this.getLrsListDetails(false, LrsFrequency.MONTHLY);
        } else {
            this.selectedFromDate = undefined;
            this.selectedToDate = undefined;
            const fromDate = moment().year(year).startOf('year').format('YYYY/MM/DD');
            const toDate = moment().year(year).endOf('year').format('YYYY/MM/DD');
            await this.getLrsListDetails(false, LrsFrequency.MONTHLY, fromDate, toDate);
        }
    }

    public async filterByMonthAndYear(dateType: 'startDate' | 'endDate', inputDate: Date, datepicker: MatDatepicker<any>) {
        if (dateType == 'startDate') {
            this.selectedFromDate = moment(inputDate).startOf('month').toDate();
        }
        if (dateType == 'endDate') {
            this.selectedToDate = moment(inputDate).endOf('month').toDate();
        }
        datepicker.close();
        if (this.selectedFromDate && this.selectedToDate && (moment(this.selectedFromDate).isBefore(this.selectedToDate))) {
            this.selectedYear = undefined;
            const fromDate = moment(this.selectedFromDate).format('YYYY/MM/DD');
            const toDate = moment(this.selectedToDate).format('YYYY/MM/DD');
            await this.getLrsListDetails(false, LrsFrequency.MONTHLY, fromDate, toDate);
        } else if (this.selectedFromDate && this.selectedToDate) {
            Toaster.toast("Please choose the correct date range", Type.Error);
        }
    }

    public accountStatementDownloadHandler() {
        const profileId = this.storageService.getItem('profile_id');
        const lenderId = this.storageService.getItem('lender_id');
        this.accountService.accountStatementDownload(lenderId,profileId)
            .then((res) => {
                console.log("DOWNLOADED", res)
                const accountStatement = res;
                let downloadUrl = URL.createObjectURL(accountStatement);
                let downloadElem = document.createElement('a');
                downloadElem.href = downloadUrl;
                downloadElem.download = 'Account_Statement_File' + '.pdf';
                downloadElem.click();
            })
            .catch((err) => {
                console.log(err)
            })
        }
}